export enum Resources {
  CREDIT_CARDS = 'CREDIT_CARDS',
  CIRGS = 'CIRGS',
  BROKERAGE = 'BROKERAGE',
  USER_MANAGEMENT = 'USER_MANAGEMENT',
  INSURERS = 'INSURERS',
}
